import { countryWiseFloorFields } from "app/utils/constants/configurations";
import { ValidURL } from "app/utils/Validations";
import cloneDeep from "lodash.clonedeep";

export const appInputChangeHandler = (e, formValues, setFormValues) => {
  e.preventDefault();
  let inputName = e.target.name;
  let nameStr = inputName.split("_");
  let name = nameStr[0];
  let inputValue =
    e.target.value != undefined &&
    e.target.value != null &&
    e.target.value != ""
      ? e.target.value
      : "";

  let appFields = cloneDeep(formValues);
  {
    appFields.map((info, i) => {
      if (nameStr[1] == i) {
        info[name].value = inputValue;
        if (name == "AppUrl") {
          if (inputValue == "" || inputValue == null) {
            info[name].details = "";
          }
        }
        info[name].touched = true;
        info[name].error = !inputValue;
        info[name].message = inputValue ? "" : info[name]["default_msg"];
      }
      return info;
    });
  }

  setFormValues(appFields);
};

export const appMultiCheckBoxChangeHandler = (e, formValues, setFormValues) => {
  //e.preventDefault();

  let inputName = e.target.name;
  let nameStr = inputName.split("_");
  let name = nameStr[0];
  let inputValue =
    e.target.value != undefined && e.target.value != null ? e.target.value : "";
  let previewsValue =
    e.target.previewsValue != undefined && e.target.previewsValue != null
      ? e.target.previewsValue
      : [];

  let checked = e.target.checked;

  if (checked) {
    //   Add
    previewsValue.push(inputValue);
  } else {
    // Remove
    const index = previewsValue.indexOf(inputValue);
    if (index > -1) {
      // only splice array when item is found
      previewsValue.splice(index, 1); // 2nd parameter means remove one item only
    }
  }

  let appFields = cloneDeep(formValues);
  {
    appFields.map((info, i) => {
      if (nameStr[1] == i) {
        info[name].value = previewsValue;
        info[name].touched = true;
        info[name].error = previewsValue.length == 0 ? true : false;
        info[name].message = previewsValue ? "" : info[name]["default_msg"];
      }
      return info;
    });
  }

  setFormValues(appFields);
};
export const appinputBlurHandler = (
  e,
  formValues,
  setFormValues,
  extraParamsObj
) => {
  e.preventDefault();
  let inputName = e.target.name;
  let nameStr = inputName.split("_");
  let name = nameStr[0];
  let index = nameStr[1];
  let validationType = formValues[index][name].type;
  let inputValue = formValues[index][name].value;
  let isRequired = formValues[index][name].required;
  let defaultMsg = formValues[index][name].default_msg;

  let errorRetObj = appvalidateField(
    validationType,
    inputValue,
    isRequired,
    defaultMsg,
    extraParamsObj
  );
  //console.log('errorRetObj', errorRetObj)
  let appFields = cloneDeep(formValues);
  {
    appFields.map((info, i) => {
      if (nameStr[1] == i) {
        info[name].value = inputValue;
        info[name].touched = true;
        info[name].error = errorRetObj.error;
        info[name].message = errorRetObj.message;
      }
      return info;
    });
  }
  //console.log('appFields', appFields)
  setFormValues(appFields);
};

export const appvalidateField = (
  validationType,
  value,
  isRequired,
  defaultMsg,
  extraParamsObj
) => {
  //console.log('isRequired', isRequired);
  //console.log('validationType', validationType, isRequired)
  let retObj = { error: false, message: "" };
  if (isRequired === false && (value == "" || value == null)) {
    return retObj;
  } else {
    switch (validationType) {
      case undefined:
        return retObj;

      case "url":
        if (value == "" || value == null) {
          retObj.error = true;
          retObj.message = "Enter Url";
        } else if (!ValidURL(value)) {
          retObj.error = true;
          retObj.message = "Enter Valid URL";
        } else {
          retObj.error = false;
          retObj.message = "";
        }
        return retObj;
      case "image_url":
        if (value == "" || value == null) {
          retObj.error = true;
          retObj.message = "Enter Url";
        } else if (!ValidURL(value)) {
          retObj.error = true;
          retObj.message = "Enter Valid URL";
        } else if (!checkURL(value)) {
          retObj.error = true;
          retObj.message = "Creative URL should be png/jpeg/jpg/gif";
        } else {
          retObj.error = false;
          retObj.message = "";
        }

      default:
        if (value == "" || value == null || value == false) {
          retObj.error = true;
          retObj.message = defaultMsg;
        }
        return retObj;
    }
  }
};

export const checkURL = (url) => {
  return url.match(/\.(jpeg|jpg|gif|png)$/) != null;
};

export const appSelectChangeHandler = (e, formValues, setFormValues) => {
  let inputName = e.target.name;
  let nameStr = inputName.split("_");
  let name = nameStr[0];

  let inputValue =
    e.target.value != undefined && e.target.value != null ? e.target.value : "";

  let appFields = cloneDeep(formValues);

  {
    appFields.map((info, i) => {
      if (nameStr[1] == i) {
        if (name == "App") {
          if (inputValue == "ssp") {
            info["AppUrl"].required = false;
            info["AppUrl"].error = false;
            info["AppUrl"].value = "";
          } else {
            info["AppUrl"].error = false;
            info["AppUrl"].value = "";
            info["AppUrl"].details = "";
            info["AppUrl"].required = true;
          }
        }
        info[name].value = inputValue;
        info[name].touched = true;
        info[name].error = inputValue == "" ? true : false;
        //info.nameStr[0].message = inputValue != "" ? "" : nameStr[1]["default_msg"]
      }
      return info;
    });
  }
  //console.log('appFields', appFields)
  setFormValues(appFields);
};

export const appFormValid = (
  formValues,
  setFormValues,
  specificCheck,
  extraParamsObj
) => {
  let valid = true;
  let formValueCloneObj = cloneDeep(formValues);

  if (formValueCloneObj.length <= 0) {
    valid = false;
  } else {
    {
      formValues.map((appInfo, key) => {
        let validationType = formValues[key]["App"].type;
        let inputValue = formValues[key]["App"].value;
        let isRequired = formValues[key]["App"].required;
        let defaultMsg = formValues[key]["App"].default_msg;
        let errorRetObj = appvalidateField(
          validationType,
          inputValue,
          isRequired,
          defaultMsg,
          extraParamsObj
        );
        let urlvalidationType = formValues[key]["AppUrl"].type;
        let urlinputValue = formValues[key]["AppUrl"].value;
        let urlisRequired = formValues[key]["AppUrl"].required;
        let urldefaultMsg = formValues[key]["AppUrl"].default_msg;
        let urlerrorRetObj = appvalidateField(
          urlvalidationType,
          urlinputValue,
          urlisRequired,
          urldefaultMsg,
          extraParamsObj
        );

        formValueCloneObj[key]["App"].error = errorRetObj.error;
        formValueCloneObj[key]["App"].message = errorRetObj.message;
        formValueCloneObj[key]["App"].touched = true;
        formValueCloneObj[key]["AppUrl"].error = urlerrorRetObj.error;
        formValueCloneObj[key]["AppUrl"].message = urlerrorRetObj.message;
        formValueCloneObj[key]["AppUrl"].touched = true;

        if (
          errorRetObj.error == false &&
          urlerrorRetObj.error == false &&
          appInfo.placementfields.length > 0
        ) {
          {
            appInfo.placementfields.map((placementInfo, index) => {
              let placevalidationType =
                formValues[key]["placementfields"][index]["PlacementName"].type;
              let placeinputValue =
                formValues[key]["placementfields"][index]["PlacementName"]
                  .value;
              let placeisRequired =
                formValues[key]["placementfields"][index]["PlacementName"]
                  .required;
              let placedefaultMsg =
                formValues[key]["placementfields"][index]["PlacementName"]
                  .default_msg;
              let placeerrorRetObj = appvalidateField(
                placevalidationType,
                placeinputValue,
                placeisRequired,
                placedefaultMsg,
                extraParamsObj
              );

              formValueCloneObj[key]["placementfields"][index][
                "PlacementName"
              ].error = placeerrorRetObj.error;
              formValueCloneObj[key]["placementfields"][index][
                "PlacementName"
              ].message = placeerrorRetObj.message;
              formValueCloneObj[key]["placementfields"][index][
                "PlacementName"
              ].touched = true;
              if (
                placeerrorRetObj.error == false &&
                placementInfo.countryWiseFields.length > 0
              ) {
                {
                  placementInfo.countryWiseFields.map((countryInfo, i) => {
                    let countryvalidationType =
                      formValues[key]["placementfields"][index][
                        "countryWiseFields"
                      ][i]["Country"].type;
                    let countryinputValue =
                      formValues[key]["placementfields"][index][
                        "countryWiseFields"
                      ][i]["Country"].value;
                    let countryisRequired =
                      formValues[key]["placementfields"][index][
                        "countryWiseFields"
                      ][i]["Country"].required;
                    let countrydefaultMsg =
                      formValues[key]["placementfields"][index][
                        "countryWiseFields"
                      ][i]["Country"].default_msg;
                    let countryerrorRetObj = appvalidateField(
                      countryvalidationType,
                      countryinputValue,
                      countryisRequired,
                      countrydefaultMsg,
                      extraParamsObj
                    );
                    formValueCloneObj[key]["placementfields"][index][
                      "countryWiseFields"
                    ][i]["Country"].error = countryerrorRetObj.error;
                    formValueCloneObj[key]["placementfields"][index][
                      "countryWiseFields"
                    ][i]["Country"].message = countryerrorRetObj.message;
                    formValueCloneObj[key]["placementfields"][index][
                      "countryWiseFields"
                    ][i]["Country"].touched = true;

                    if (countryerrorRetObj.error == true) {
                      valid = false;
                      return false;
                    }
                  });
                }
              } else if (
                placeerrorRetObj.error == false &&
                placementInfo.countryWiseFields.length <= 0
              ) {
                return true;
              } else {
                valid = false;
                return false;
              }
            });
          }
        } else if (
          errorRetObj.error == false &&
          urlerrorRetObj.error == false &&
          appInfo.placementfields.length <= 0
        ) {
          return true;
        } else {
          valid = false;
          return false;
        }
      });
    }
  }

  if (valid == false) {
    setFormValues(formValueCloneObj);
  }
  return valid;
};

export const placementInputChangeHandler = (e, formValues, setFormValues) => {
  //e.preventDefault();
  let inputName = e.target.name;
  let nameStr = inputName.split("_");
  let name = nameStr[0];
  let appindex = nameStr[1];
  let placeIndex = nameStr[2];
  let inputValue;
  let appFields = cloneDeep(formValues);
  if (e.target.type == "checkbox") {
    inputValue = e.target.checked;

    {
      appFields.map((info, i) => {
        if (appindex == i) {
          {
            info.placementfields.map((placeinfo, k) => {
              if (placeIndex == k) {
                placeinfo[name].value = inputValue;
                placeinfo[name].touched = true;
                placeinfo[name].error = !inputValue;
                if (
                  inputValue == true &&
                  placeinfo.countryWiseFields.length <= 0 &&
                  name == "OverrideFloorSetting"
                ) {
                  placeinfo.countryWiseFields.push(countryWiseFloorFields);
                }
                //placeinfo[name].message = inputValue ? "" : info[name]["default_msg"]
              }
            });
          }
        }
        return info;
      });
    }
  } else {
    inputValue =
      e.target.value != undefined &&
      e.target.value != null &&
      e.target.value != ""
        ? e.target.value
        : "";

    {
      appFields.map((info, i) => {
        if (appindex == i) {
          {
            info.placementfields.map((placeinfo, k) => {
              if (placeIndex == k) {
                placeinfo[name].value = inputValue;
                placeinfo[name].touched = true;

                if (placeinfo[name].required == true) {
                  placeinfo[name].error = !inputValue;
                }

                //placeinfo[name].message = inputValue ? "" : info[name]["default_msg"]
              }
            });
          }
        }
        return info;
      });
    }
  }
  console.log("appFields", appFields);
  setFormValues(appFields);
};

export const placementinputBlurHandler = (
  e,
  formValues,
  setFormValues,
  extraParamsObj
) => {
  e.preventDefault();
  let inputName = e.target.name;
  let nameStr = inputName.split("_");
  let name = nameStr[0];
  let appindex = nameStr[1];
  let placeId = nameStr[2];

  let validationType =
    formValues[appindex]["placementfields"][placeId][name].type;
  let inputValue = formValues[appindex]["placementfields"][placeId][name].value;
  let isRequired =
    formValues[appindex]["placementfields"][placeId][name].required;
  let defaultMsg =
    formValues[appindex]["placementfields"][placeId][name].default_msg;

  let errorRetObj = appvalidateField(
    validationType,
    inputValue,
    isRequired,
    defaultMsg,
    extraParamsObj
  );

  let appFields = cloneDeep(formValues);
  {
    appFields.map((info, i) => {
      if (appindex == i) {
        {
          info.placementfields.map((placeinfo, k) => {
            if (placeId == k) {
              placeinfo[name].value = inputValue;
              placeinfo[name].touched = true;
              placeinfo[name].error = errorRetObj.error;
              placeinfo[name].message = errorRetObj.message;
            }
          });
        }
      }
      return info;
    });
  }
  setFormValues(appFields);
};

export const appMultiSelectChangeHandler = (e, formValues, setFormValues) => {
  let inputName = e.target.name;
  let nameStr = inputName.split("_");
  let inputValue =
    e.target.value != undefined && e.target.value != null ? e.target.value : "";
  let name = nameStr[0];
  let appindex = nameStr[1];
  let placeId = nameStr[2];
  let countryId = nameStr[3];
  let appFields = cloneDeep(formValues);
  {
    appFields.map((info, i) => {
      if (appindex == i) {
        {
          info.placementfields.map((placeinfo, k) => {
            if (placeId == k) {
              {
                placeinfo.countryWiseFields.map((countryInfo, index) => {
                  if (index == countryId) {
                    countryInfo[name].value = inputValue;
                    countryInfo[name].touched = true;
                    countryInfo[name].error = inputValue == "" ? true : false;
                    countryInfo[name].message = inputValue
                      ? ""
                      : countryInfo[name]["default_msg"];
                  }
                });
              }
            }
          });
        }
      }
      return info;
    });
  }
  setFormValues(appFields);
};

export const appMultiSelectBlurHandler = (
  e,
  formValues,
  setFormValues,
  extraParamsObj
) => {
  e.preventDefault();
  let inputName = e.target.name;
  let nameStr = inputName.split("_");
  let name = nameStr[0];
  let appindex = nameStr[1];
  let placeId = nameStr[2];
  let countryId = nameStr[3];

  let validationType =
    formValues[appindex]["placementfields"][placeId]["countryWiseFields"][
      countryId
    ][name].type;
  let inputValue =
    formValues[appindex]["placementfields"][placeId]["countryWiseFields"][
      countryId
    ][name].value;
  let isRequired =
    formValues[appindex]["placementfields"][placeId]["countryWiseFields"][
      countryId
    ][name].required;
  let defaultMsg =
    formValues[appindex]["placementfields"][placeId]["countryWiseFields"][
      countryId
    ][name].default_msg;

  let errorRetObj = appvalidateField(
    validationType,
    inputValue,
    isRequired,
    defaultMsg,
    extraParamsObj
  );

  let appFields = cloneDeep(formValues);
  {
    appFields.map((info, i) => {
      if (appindex == i) {
        {
          info.placementfields.map((placeinfo, k) => {
            if (placeId == k) {
              {
                placeinfo.countryWiseFields.map((countryInfo, index) => {
                  if (index == countryId) {
                    countryInfo[name].value = inputValue;
                    countryInfo[name].touched = true;
                    countryInfo[name].error = errorRetObj.error;
                    countryInfo[name].message = errorRetObj.message;
                  }
                });
              }
            }
          });
        }
      }
      return info;
    });
  }
  setFormValues(appFields);
};

export const crmFormValid = (
  formValues,
  setFormValues,
  specificCheck,
  extraParamsObj
) => {
  let valid = true;
  let formValueCloneObj = cloneDeep(formValues);
  if (formValueCloneObj.length <= 0) {
    valid = false;
  } else {
    {
      formValues.map((crmInfo, key) => {
        let validationType = formValues[key]["Crm"].type;
        let inputValue = formValues[key]["Crm"].value;
        let isRequired = formValues[key]["Crm"].required;
        let defaultMsg = formValues[key]["Crm"].default_msg;
        let crmerrorRetObj = appvalidateField(
          validationType,
          inputValue,
          isRequired,
          defaultMsg,
          extraParamsObj
        );
        let credvalidationType = formValues[key]["CredentialJson"].type;
        let credinputValue = formValues[key]["CredentialJson"].value;
        let credisRequired = formValues[key]["CredentialJson"].required;
        let creddefaultMsg = formValues[key]["CredentialJson"].default_msg;
        let crederrorRetObj = appvalidateField(
          credvalidationType,
          credinputValue,
          credisRequired,
          creddefaultMsg,
          extraParamsObj
        );

        let dbvalidationType = formValues[key]["DatabaseUrl"].type;
        let dbinputValue = formValues[key]["DatabaseUrl"].value;
        let dbisRequired = formValues[key]["DatabaseUrl"].required;
        let dbdefaultMsg = formValues[key]["DatabaseUrl"].default_msg;
        let dberrorRetObj = appvalidateField(
          dbvalidationType,
          dbinputValue,
          dbisRequired,
          dbdefaultMsg,
          extraParamsObj
        );

        let tablevalidationType = formValues[key]["TableName"].type;
        let tableinputValue = formValues[key]["TableName"].value;
        let tableisRequired = formValues[key]["TableName"].required;
        let tabledefaultMsg = formValues[key]["TableName"].default_msg;
        let tableerrorRetObj = appvalidateField(
          tablevalidationType,
          tableinputValue,
          tableisRequired,
          tabledefaultMsg,
          extraParamsObj
        );

        formValueCloneObj[key]["Crm"].error = crmerrorRetObj.error;
        formValueCloneObj[key]["Crm"].message = crmerrorRetObj.message;
        formValueCloneObj[key]["Crm"].touched = true;
        formValueCloneObj[key]["CredentialJson"].error = crederrorRetObj.error;
        formValueCloneObj[key]["CredentialJson"].message =
          crederrorRetObj.message;
        formValueCloneObj[key]["CredentialJson"].touched = true;
        formValueCloneObj[key]["DatabaseUrl"].error = dberrorRetObj.error;
        formValueCloneObj[key]["DatabaseUrl"].message = dberrorRetObj.message;
        formValueCloneObj[key]["DatabaseUrl"].touched = true;
        formValueCloneObj[key]["TableName"].error = tableerrorRetObj.error;
        formValueCloneObj[key]["TableName"].message = tableerrorRetObj.message;
        formValueCloneObj[key]["TableName"].touched = true;

        if (
          dberrorRetObj.error == true ||
          crederrorRetObj.error == true ||
          crmerrorRetObj == true ||
          tableerrorRetObj.error == true
        ) {
          valid = false;
          return false;
        }
      });
    }
  }

  if (valid == false) {
    setFormValues(formValueCloneObj);
  }
  return valid;
};

export const checkAllRequiredPublisherFieldsFilled = (formValues) => {
  let validate = true;
  for (var k in formValues) {
    var info = formValues[k];
    if (
      info.required == true &&
      (info.value == "" ||
        info.value == null ||
        info.value == false ||
        info.error == true)
    ) {
      validate = false;
      break;
    }
  }

  if (formValues.CountryWiseFloors.length > 0) {
    {
      formValues.CountryWiseFloors.map((info) => {
        if (
          info.Country.required == true &&
          (info.Country.value == "" ||
            info.Country.value == null ||
            info.Country.error == undefined)
        ) {
          validate = false;
          return false;
        }
      });
    }
  }

  return validate;
};

export const finalCrmValidation = (formValues) => {
  let validate = true;
  if (formValues.length <= 0) {
    validate = false;
  } else {
    {
      formValues.map((crmInfo, i) => {
        if (crmInfo.Crm.delete == false) {
          if (
            (crmInfo.CredentialJson.required == true ||
              crmInfo.Crm.required == true ||
              crmInfo.DatabaseUrl.required == true ||
              crmInfo.TableName.required == true) &&
            (crmInfo.CredentialJson.value == "" ||
              crmInfo.CredentialJson.value == null ||
              crmInfo.CredentialJson.error == true ||
              crmInfo.Crm.value == "" ||
              crmInfo.Crm.value == null ||
              crmInfo.Crm.error == true ||
              crmInfo.DatabaseUrl.value == "" ||
              crmInfo.DatabaseUrl.value == null ||
              crmInfo.DatabaseUrl.error == true ||
              crmInfo.TableName.value == "" ||
              crmInfo.TableName.value == null ||
              crmInfo.TableName.error == true)
          ) {
            validate = false;
            return false;
          }
        }
      });
    }
  }

  //console.log('crmvalidate', validate)
  return validate;
};

export const finalAppValidation = (formValues) => {
  let validate = true;

  {
    formValues.map((appInfo, i) => {
      if (appInfo.App.delete == false) {
        if (
          (appInfo.App.required == true &&
            (appInfo.App.value == "" ||
              appInfo.App.value == null ||
              appInfo.App.error == undefined)) ||
          (appInfo.AppUrl.required == true &&
            (appInfo.AppUrl.value == "" ||
              appInfo.AppUrl.value == null ||
              appInfo.AppUrl.error == true))
        ) {
          validate = false;
          return false;
        } else if (appInfo.placementfields.length > 0) {
          {
            appInfo.placementfields.map((placeInfo) => {
              if (placeInfo.PlacementName.delete == false) {
                if (
                  placeInfo.PlacementName.required == true &&
                  (placeInfo.PlacementName.value == "" ||
                    placeInfo.PlacementName.value == null ||
                    placeInfo.PlacementName.error == undefined)
                ) {
                  validate = false;
                  return false;
                } else if (placeInfo.countryWiseFields.length > 0) {
                  {
                    placeInfo.countryWiseFields.map((info) => {
                      if (
                        info.Country.required == true &&
                        (info.Country.value == "" ||
                          info.Country.value == null ||
                          info.Country.error == undefined)
                      ) {
                        validate = false;
                        return false;
                      }
                    });
                  }
                }
              }
            });
          }
        }
      }
    });
  }
  return validate;
};

export const countryListArray = (countryList) => {
  let countries = [];
  {
    countryList.map((info) => {
      countries.push(info.id);
    });
  }
  return countries.join(",");
};

export const CountryListArrOfObj = (countryList, countries) => {
  let countriesArr = [];
  {
    countryList.map((info) => {
      if (countries.includes(info.id)) {
        countriesArr.push(info);
      }
    });
  }

  return countriesArr;
};

export const countryFloorMultiSelectChangeHandler = (
  e,
  formValues,
  setFormValues
) => {
  let inputName = e.target.name;
  let nameStr = inputName.split("_");
  let inputValue =
    e.target.value != undefined && e.target.value != null ? e.target.value : "";
  let name = nameStr[0];

  let countryId = nameStr[1];
  let detailFields = cloneDeep(formValues);

  detailFields.CountryWiseFloors.map((countryInfo, index) => {
    if (index == countryId) {
      countryInfo[name].value = inputValue;
      countryInfo[name].touched = true;
      countryInfo[name].error = inputValue == "" ? true : false;
      countryInfo[name].message = inputValue
        ? ""
        : countryInfo[name]["default_msg"];
    }
  });

  setFormValues(detailFields);
};
